import React from 'react';
import configuration from '../../utils/config.js';

const ClientLogo = ({ record, translate }) => (
	<div >
        <img src={configuration.logos + 'clients/logo_' + record.id + '.png'} alt="" height="30px"/>
	</div>
);

export default  ClientLogo ;

